import { Drawer, Form, Responsive } from 'connex-cds';
import React from 'react';
import { useTicketContext } from '../../../TicketContext';
import { PaymentMethodDesktop } from './PaymentMethodDesktop';
import { PaymentMethodMobile } from './PaymentMethodMobile';
import getProducts from '../../../getProducts';

export const PaymentMethod = () => {
  const { validateForm, resetForm, setFieldValue, values } = Form.useFormContext();
  const { ticket, paymentMethod } = useTicketContext();

  const handleChange = React.useCallback(
    event => {
      const value = event?.target?.value;
      const name = event?.target?.name;

      setFieldValue(name, name === 'isExpectedPaymentMethod' ? value !== 'other' : value);
    },
    [setFieldValue]
  );

  const handleAmountChange = React.useCallback(
    event => {
      setFieldValue('paymentAmount', event);
    },
    [setFieldValue]
  );

  const productsData = React.useMemo(
    () => getProducts(ticket?.lineItems, values?.lineItems, false),
    [ticket?.lineItems, values?.lineItems]
  );

  React.useEffect(() => {
    validateForm();
  }, [validateForm]);

  React.useEffect(() => {
    if (ticket === null) {
      resetForm({ reinitialize: true });
    }
  }, [resetForm, ticket]);

  React.useEffect(() => {
    if (!values?.paymentMethodRef) {
      setFieldValue('paymentMethodRef', paymentMethod?.crn);
    }
  }, [paymentMethod?.crn, setFieldValue]);

  return (
    <Drawer.DrawerProvider>
      <Responsive>
        <PaymentMethodMobile
          handleChange={handleChange}
          handleAmountChange={handleAmountChange}
          productsData={productsData}
        />
        <PaymentMethodDesktop
          handleChange={handleChange}
          handleAmountChange={handleAmountChange}
          productsData={productsData}
        />
      </Responsive>
    </Drawer.DrawerProvider>
  );
};
